/**
 * Per-path org access guard (owners vs members).
 */

import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { useQAPerspective } from '@/contexts/QAPerspectiveContext'
import { canAccessOrgPath } from '@/lib/routing/org-route-access'
import { mapActualRoleToRouteRole, mapUserRoleToRouteRole } from '@/lib/routing/can-access-route'

interface OrgSubRouteProps {
  path: string
  children: ReactNode
}

export function OrgSubRoute({ path, children }: OrgSubRouteProps) {
  const { accountData } = useAuth()
  const { effectiveRole } = useQAPerspective()

  const actualRole = mapUserRoleToRouteRole(accountData?.role)
  const effective = mapActualRoleToRouteRole(effectiveRole)
  const isActualAdmin = actualRole === 'admin'

  if (!canAccessOrgPath(path, effective, isActualAdmin)) {
    return <Navigate to="/org/dashboard" replace />
  }

  return <>{children}</>
}
